import { keyMirror } from '@gilbarbara/helpers';

import { Status } from 'types';

export const ActionTypes = keyMirror({
  GITHUB_GET_REPOS_REQUEST: undefined,
  GITHUB_GET_REPOS_SUCCESS: undefined,
  GITHUB_GET_REPOS_FAILURE: undefined,
  HIDE_ALERT: undefined,
  SHOW_ALERT: undefined,
  SET_APP_OPTIONS: undefined,
  USER_LOGIN_REQUEST: undefined,
  USER_LOGIN_SUCCESS: undefined,
  USER_LOGIN_FAILURE: undefined,
  USER_LOGOUT_REQUEST: undefined,
  USER_LOGOUT_SUCCESS: undefined,
  USER_LOGOUT_FAILURE: undefined,
  USER_ANSWER_REQUEST: undefined,
  USER_ANSWER_SUCCESS: undefined,
  USER_ANSWER_FAILURE: undefined,
  USER_SET_SESSION: undefined,
  USER_SET_NAME: undefined,
  USER_SET_EMAIL: undefined,
  USER_SET_LISTEN: undefined,
  USER_SET_SAVING: undefined,
  USER_SPEAK_REQUEST: undefined,
  USER_SPEAK_SUCCESS: undefined,
  USER_SPEAK_FAILURE: undefined,
  USER_EXPORT_REQUEST: undefined,
  USER_EXPORT_SUCCESS: undefined,
  USER_EXPORT_FAILURE: undefined,
});

export const STATUS: Status = {
  IDLE: 'idle',
  RUNNING: 'running',
  READY: 'ready',
  SUCCESS: 'success',
  ERROR: 'error',
};
